module.exports = __webpack_public_path__ + "static/media/parrot.f3d35353.svg";